export default {
  unreadCount: 0,
  notificationList: [],
  isNotDisturb: false,
};
